import React from "react";

type AuthContextType = {};

const defaultValue: AuthContextType = {};

export const AuthContext = React.createContext(defaultValue);

export default function AuthContextProvier(props: {
  children: React.ReactNode;
  token?: string | null;
  userIsAdm?: boolean;
}) {
  return (
    <AuthContext.Provider value={{}}>{props.children}</AuthContext.Provider>
  );
}
